import { render, staticRenderFns } from "./capacitacion.vue?vue&type=template&id=df48d838"
import script from "./capacitacion.vue?vue&type=script&lang=js"
export * from "./capacitacion.vue?vue&type=script&lang=js"
import style0 from "./capacitacion.vue?vue&type=style&index=0&id=df48d838&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports